<template>
  <div>
    <v-button
      v-if="!passwordReset"
      @click.native="resetPassword()"
      :working="working"
    >
      Passwort erneuern (per Mail verschicken)
    </v-button>
    <div class="form-control" disabled v-else>
      <strong>Passwort wurde verschickt</strong>
    </div>
    <div
      v-if="attribute.errors !== null"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    }
  },
  data() {
    return {
      passwordReset: false,
      working: false,
    };
  },
  methods: {
    resetPassword() {
      this.working = true;
      this.$http.post(`/api/v1/user/${this.value}/password-reset`)
      .then(() => {
        this.passwordReset = true;
      })
      .finally(() => {
        this.working = false;
      });
    }
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
  }
}
</script>
